import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import CourseSelector from '../components/CourseSelector';
import { Loader2 } from 'lucide-react';

const CourseSelectionPage = () => {
  const { user, selectCourse, isAuthenticated, loading: authLoading } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const [selectedCourse, setSelectedCourse] = useState(user?.selected_course || 'pt-en');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      window.location.href = '/login';
    }
  }, [authLoading, isAuthenticated]);

  const handleConfirm = async () => {
    if (!selectedCourse) return;
    
    setLoading(true);
    setError('');
    
    try {
      await selectCourse(selectedCourse);
      window.location.href = '/';
    } catch (err) {
      console.error('Error selecting course:', err);
      setError(t('common.error') + ': ' + (err.response?.data?.detail || err.message));
      setLoading(false);
    }
  };

  if (authLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-2xl shadow-xl p-6 border border-border">
          {error && (
            <div className="mb-4 p-3 bg-destructive/10 border border-destructive/20 rounded-lg text-destructive text-sm">
              {error}
            </div>
          )}
          
          <CourseSelector
            selectedCourse={selectedCourse}
            onSelectCourse={setSelectedCourse}
            onConfirm={handleConfirm}
            showConfirmButton={true}
          />
          
          {loading && (
            <div className="mt-4 flex items-center justify-center gap-2 text-muted-foreground">
              <Loader2 className="w-4 h-4 animate-spin" />
              <span>{t('common.loading')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseSelectionPage;
